import { render, staticRenderFns } from "./GoodsTransferView.vue?vue&type=template&id=5d144e7c"
import script from "./GoodsTransferView.vue?vue&type=script&lang=js"
export * from "./GoodsTransferView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports